<template>
    <section id="about" class="about">
        <div class="about-content">
            <div class="container" style="max-width: 1300px">
                <div class="row row-about" style="justify-content: space-around;">
                    <div class="content">
                        <div v-scrollanimation>
                            <h2 class="main-title">
                                {{ $t('about.welcome') }}
                                <span
                                    style="font-weight:bold"
                                >{{ $t('about.peak_link') }}</span>
                            </h2>
                            <div
                                class="div-about col-lg-12"
                                style="text-align: center;margin-top: 30px"
                            >
                                <!-- <ul class="list-about"> -->
                                <!-- <li class="item-about row"> -->
                                <!-- <b-icon icon="check-lg"></b-icon> -->
                                <p class="text-muted">{{ desc }}</p>
                                <!-- <router-link to="about"> -->
                                <a @click="goToAbout()">
                                    <my-button2 :text=" $t('view_more')"></my-button2>
                                </a>
                                <!-- </router-link> -->
                                <!-- </li> -->
                                <!-- <li class="item-about row">
                                        <b-icon icon="check-lg"></b-icon>
                                        <p>
                                            The company includes a full team of professionals from all disciplines
                                            necessary to implement websites and applications for commercial and service
                                            activities in
                                            its various fields of work.
                                        </p>
                                    </li>
                                    <li class="item-about row">
                                        <b-icon icon="check-lg"></b-icon>
                                        <p>
                                            Honesty and mutual trust are among our most important goals and
                                            the basis of our success and continuity so far.
                                        </p>
                                    </li>
                                    <li class="item-about row">
                                        <b-icon icon="check-lg"></b-icon>
                                        <p>
                                            We believe in the importance of digital
                                            content and the importance of websites and applications to bring about change,
                                            and
                                            development, and increase profits if used in the best way.
                                        </p>
                                    </li>
                                    <li class="item-about row">
                                        <b-icon icon="check-lg"></b-icon>
                                        <p>
                                            Our goal is to leave a
                                            qualitative impact and imprint on our services, to be the leading company and
                                            the
                                            first of
                                            its kind
                                        </p>
                                </li>-->
                                <!-- </ul> -->
                            </div>
                        </div>
                    </div>
                    <!-- <div class="animation">
                        <img src="../assets/img/logo-color-height.webp" v-scrollanimation alt="Peak link logo"
                            class="about-img">
                    </div>-->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import MyButton2 from "@/components/MyButton2.vue"
export default {
    name: "About",
    components: {
        MyButton2
    },
    data() {
        return {
            desc: "",
            lang: ''
        };
    },
    methods: {
        goToAbout() {
            // console.log("33333333333")
            this.$router.replace({ name: 'about' })
        }
    },
    mounted() {
        this.lang = localStorage.getItem("lang")
        if (this.lang == 'en')
            this.desc = this.$store.state.about_section_data[0].description.en
        else
            this.desc = this.$store.state.about_section_data[0].description.ar
        // console.log(this.$store.state.about_section_data)
    }
};

</script>


<style lang="scss">
html:lang(en) .about .main-title {
    font-family: Saira, sans-serif;
}

.about .main-title {
    font-size: 35px;
    text-align: center;
    color: var(--main-blue);
}

@media (min-width: 992px) {
    #about {
        padding: 10px 0px;
    }

    .about .about-content {
        margin-top: 40px;
    }

    .about .animation {
        display: flex;
        flex-flow: column;
        align-items: flex-end;
    }

    .about .content {
        max-width: 79% !important;
        display: flex;
        flex-flow: column;
        align-items: self-start;
    }

    .about .about-img {
        width: 300px;
        margin-top: 60px;
    }
}

@media (max-width: 991px) {
    #about {
        padding: 10px;
    }
    .about .main-title {
        font-size: 28px !important;
    }

    .about .about-content {
        margin-top: 0px;
    }

    .about .content {
        margin-top: 40px;
        // max-width: 70%;
    }

    .about .row-about {
        justify-content: space-evenly;
    }

    .about .about-img {
        width: 200px !important;
    }

    .about .about-img {
        margin-top: 10px;
        margin-bottom: 100px;
    }
}

.about .note {
    color: var(--main-color);
    font-size: 11px;
    font-weight: bold;
    letter-spacing: 2px;
}

.about .item-paragraph {
    color: var(--gray);
    font-size: 17px;
}

.about .items {
    display: flex;
    flex-direction: row;
    margin-top: 20px;
    text-align: center;
}

.about .item-icon {
    color: var(--main-color);
    font-size: 20px;
    margin: 3px 10px;
}

.about .content .before-enter {
    opacity: 0;
    transform: translateY(100px);
    transition: all 1s ease-out;
}

.about .content .enter {
    opacity: 1;
    transform: translateY(0px);
}

.about .animation .before-enter {
    opacity: 0;
    transform: translateY(100px);
    transition: all 2s ease-out;
}

.about .animation .enter {
    opacity: 1;
    transform: translateY(0px);
}

.about .list-about {
    list-style: none;
    padding-left: 20px;
    font-size: 14.5px;
}

.about .bi-check-lg {
    color: var(--main-green);
    font-size: 18px;
    font-weight: bold;
    margin-right: 15px;
    margin-top: 5px;
}

.about .list-about .row {
    flex-wrap: inherit;
}
</style>
